// extracted by mini-css-extract-plugin
module.exports = {"CheckboxTextInput":"CheckboxTextInput-module--CheckboxTextInput--27mQt"};